export const inputStep = "0.0001";
export const maxInputNumber = 2147483647;
